import { ComponentType } from 'react';

import { IconType } from 'react-icons';
import { VeryLowRisk } from '../icons/questionnaire/question1/VeryLowRisk';
import { LowRisk } from '../icons/questionnaire/question1/LowRisk';
import { ModerateRisk } from '../icons/questionnaire/question1/ModerateRisk';
import { HighRisk } from '../icons/questionnaire/question1/HighRisk';
import { ShortTerm } from '../icons/questionnaire/question2/ShortTerm';
import { Medium } from '../icons/questionnaire/question2/Medium';
import { MediumToLongTerm } from '../icons/questionnaire/question2/MediumToLongTerm';
import { LongTerm } from '../icons/questionnaire/question2/LongTerm';
import { InvestMore } from '../icons/questionnaire/question3/InvestMore';
import { StayInvested } from '../icons/questionnaire/question3/StayInvested';
import { ExitAllInvestments } from '../icons/questionnaire/question3/ExitAllInvestments';
import { PartialExit } from '../icons/questionnaire/question3/PartialExit';
import { Level1 } from '../icons/questionnaire/question4/Level1';
import { Level2 } from '../icons/questionnaire/question4/Level2';
import { Level3 } from '../icons/questionnaire/question4/Level3';
import { Level4 } from '../icons/questionnaire/question4/Level4';

export interface Option {
    id: string;
    text: string;
    subText: string;
    riskPoints: number;
    icon?: IconType | ComponentType;
    details?: any
}

export interface Question {
    id: number;
    questionText: string;
    options: Option[];

}

export const questionnaireData: Question[] = [
    {
        id: 1,
        questionText: 'How do you prefer your mutual fund portfolio to grow?',
        options: [
            { id: '1-1', text: 'Grow safely even if returns are low', subText: 'Very low risk', riskPoints: 1, icon: VeryLowRisk, details: { averageReturns: '6% p.a.', worstCase: '-1%', bestCase: '+10%' } },
            { id: '1-2', text: 'Grow slowly with some safety', subText: 'Low risk', riskPoints: 2, icon: LowRisk, details: { averageReturns: '9% p.a.', worstCase: '-3%', bestCase: '+15%' } },
            { id: '1-3', text: 'Grow well with some ups and downs', subText: 'Moderate risk', riskPoints: 3, icon: ModerateRisk, details: { averageReturns: '12% p.a.', worstCase: '-7% ', bestCase : '+20%', } },
            { id: '1-4', text: 'Grow faster even if it means high risk', subText: 'High risk', riskPoints: 5, icon: HighRisk, details: { averageReturns: '15% p.a.', worstCase: '-10%', bestCase : '+25%' } },
        ],
    },
    {
        id: 2,
        questionText: 'What is your investment horizon?',
        options: [
            { id: '2-1', text: 'Short-term goals', subText: 'Less than 3 years', riskPoints: 1, icon: ShortTerm },
            { id: '2-2', text: 'Medium-term goals', subText: '3–5 years', riskPoints: 2, icon: Medium },
            { id: '2-3', text: 'Medium to long-term goals', subText: '5–7 years', riskPoints: 3, icon: MediumToLongTerm },
            { id: '2-4', text: 'Long-term wealth creation', subText: 'More than 7 years', riskPoints: 5, icon: LongTerm },
        ],
    },
    {
        id: 3,
        questionText: 'If your investments fall by 20% within a few months, what would you do?',
        options: [
            { id: '3-1', text: 'Exit all investments immediately', subText: 'to prevent further loss', riskPoints: 1, icon: ExitAllInvestments },
            { id: '3-2', text: 'Exit partially', subText: 'and shift to safer options', riskPoints: 2, icon: PartialExit },
            { id: '3-3', text: 'Stay invested', subText: 'I\'m comfortable with market fluctuations', riskPoints: 3, icon: StayInvested },
            { id: '3-4', text: 'Invest more', subText: 'I will find ways to invest more and average my cost', riskPoints: 5, icon: InvestMore },
        ],
    },
    {
        id: 4,
        questionText: 'How would you describe your investment knowledge?',
        options: [
            { id: '4-1', text: 'Very limited', subText: 'I\'m only familiar with savings accounts and fixed deposits', riskPoints: 1, icon: Level1 },
            { id: '4-2', text: 'Basic', subText: 'I know a little about mutual funds', riskPoints: 2, icon: Level2 },
            { id: '4-3', text: 'Moderate', subText: 'I understand mutual fund categories but don\'t understand enough to make my own decisions', riskPoints: 3, icon: Level3 },
            { id: '4-4', text: 'Good', subText: 'I can do research and decide where to invest my money efficiently', riskPoints: 5, icon: Level4 },
        ],
    },
];